import { FC } from 'react';

import { DialogDescription } from '@radix-ui/react-dialog';

import { twMerge } from 'tailwind-merge';

import { useViewportStore } from '../../../lib';
import { DialogTitle } from '../../dialog';
import { DrawerHeader } from '../../drawer';
import { VisuallyHidden } from '../../visually-hidden';
import { TModalTemplateTitle } from './types';

export const ModalTemplateTitle: FC<TModalTemplateTitle> = ({
  id,
  title,
  description,
  isHasButtons,
  className,
  titleClassName,
  descriptionClassName,
}) => {
  const isMobile = useViewportStore((state) => state.isMobile);
  return (
    <div className={twMerge('mx-auto py-3 text-center', className)}>
      {title ? (
        isMobile ? (
          <DrawerHeader
            className={twMerge(
              'p-0 heading-m',
              isHasButtons && 'px-[66px]',
              titleClassName,
            )}
          >
            {title}
          </DrawerHeader>
        ) : (
          <DialogTitle
            className={twMerge(
              'p-0 heading-m',
              isHasButtons && 'px-[66px]',
              titleClassName,
            )}
          >
            {title}
          </DialogTitle>
        )
      ) : (
        !isMobile && (
          <VisuallyHidden>
            <DialogTitle>{id}</DialogTitle>
          </VisuallyHidden>
        )
      )}

      {description &&
        (isMobile ? (
          <p
            className={twMerge(
              'px-3 pt-3 text-base-100 typography-16r',
              descriptionClassName,
            )}
          >
            {description}
          </p>
        ) : (
          <DialogDescription
            className={twMerge(
              'p-0 px-3 pt-3 text-base-100 typography-16r',
              descriptionClassName,
            )}
          >
            {description}
          </DialogDescription>
        ))}
    </div>
  );
};
